(function () {
  const KEY = 'cn-theme';
  const root = document.documentElement;

  function apply(theme) {
    root.setAttribute('data-cn-theme', theme === 'dark' ? 'dark' : 'light');
  }

  function updateIcons() {
    const isDark = root.getAttribute('data-cn-theme') === 'dark';
    document.querySelectorAll('[data-cn-toggle-theme]').forEach(btn => {
      const sun = btn.querySelector('.cn-icon--sun');
      const moon = btn.querySelector('.cn-icon--moon');
      if (sun) sun.style.display = isDark ? 'none' : 'block';
      if (moon) moon.style.display = isDark ? 'block' : 'none';
    });
  }

  // Init
  const saved = localStorage.getItem(KEY);
  if (saved) {
    apply(saved);
  } else {
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    apply(prefersDark ? 'dark' : 'light');
  }

  document.addEventListener('DOMContentLoaded', updateIcons);

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-cn-toggle-theme]');
    if (!btn) return;
    e.preventDefault();
    const isDark = root.getAttribute('data-cn-theme') === 'dark';
    const next = isDark ? 'light' : 'dark';
    apply(next);
    try { localStorage.setItem(KEY, next); } catch (_) {}
    updateIcons();
  });
})();